import useBaseMessageError from './useBaseMessageError';
import useSnackbar from './useSnackbar';

function useMessangerError() {
  return useBaseMessageError({ hook: useSnackbar });
}

export default useMessangerError;
